// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ContactMenu } from './contact-menu'

const COMPONENT_ID = 'contactMenu'

interface Prop {
  userId: string
}

export const showContactMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: ContactMenu },
}
